import { useSpotSwapUserConfig } from '~/state/dex/hooks'
import DefaultLoading from './DefaultLoading'
import CrossLoading from './CrossLoading'

const Loading: React.FC = () => {
  const { isCrossSwap } = useSpotSwapUserConfig()

  return isCrossSwap ? <CrossLoading /> : <DefaultLoading />
}

export default Loading
